const signupConstant={
    SIGNUP:'Signup',
    ALREADY_USER:'Already a user',
    LOGIN:'Login',
}
export default signupConstant;